import styled from 'styled-components';

import {ms} from '../../../../styles';
import {Icon as UIKitIcon} from '../../../../uikit/Icon';

export const Icon = styled(UIKitIcon).attrs(p => ({
  color: p.color,
  size: p.size || 'xl',
}))`
  margin-block-end: ${ms(25)};
  align-self: center;
`;
